export default class Order {
  constructor(props) {
    this.id = null
    this.deliveryMethod = 0
    this.paymentMethod = 0
    this.incomeReturnMethod = 0
    this.wallet = null
    this.selectedCard = null
    this.paymentDot = null
    this.shop = {
      name: null,
      orderInnerId: null,
      surcharge: 0,
    }
    this.dots = []
    this.city = 2
    this.services = []
    this.promocode = {}

    Object.keys(props).forEach(key => {
      this[key] = props?.[key]
    })

    const requiredArrays = ['services']

    requiredArrays.forEach(key => {
      if (!this[key]) {
        this[key] = props?.[key] || []
      }
    })
  }
}
